import { SimplePieChart } from "./PieChart";

export { SimplePieChart };



// WEBPACK FOOTER //
// ./client/modules/core/Chart/RadialChart/index.ts